import type React from 'react';
import { useEffect, useState } from 'react';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import { DateTime } from 'luxon';

type TimeFieldCellProps = {
  value: DateTime | undefined;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  slotProps?: {
    textField?: {
      onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
      inputProps?: Record<string, unknown>;
    };
  };
  'data-timefield-row'?: number | string;
  'data-timefield-name'?: string;
};

// Buffers the displayed value in local state so transient parent re-renders
// (Redux dispatches, polling, optimistic-state churn) cannot flash a stale
// value into the input. The local value only resyncs when the prop's ISO
// actually differs.
function TimeFieldCell({ value, onBlur, ...rest }: TimeFieldCellProps) {
  const [localValue, setLocalValue] = useState<DateTime | null>(value ?? null);
  const valueISO = value?.toISO() ?? null;

  useEffect(() => {
    setLocalValue(value ?? null);
  }, [valueISO]);

  return (
    <TimeField
      value={localValue}
      onChange={(newValue: DateTime | null) => setLocalValue(newValue)}
      onBlur={onBlur}
      {...(rest as object)}
    />
  );
}

export { TimeFieldCell };
export type { TimeFieldCellProps };
